<template>
  <div :class="[{ 'nav-open': $sidebar.showSidebar }, { rtl: $route.meta.rtlActive }]">
    <notifications></notifications>
    <side-bar
      class="frontend-sidebar"
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <hotel-selection></hotel-selection>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'dashboard',
            path: '/dashboard',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Pricing',
            icon: 'euro',
            path: '/pricing',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Calendar & Events',
            icon: 'event',
            path: '/events',
          }"
        >
        </sidebar-item>
        <!-- <sidebar-item
          :link="{
            name: 'Allotment & Restrictions',
            icon: 'rule',
            path: '/allotment-restrictions'
          }"
        >
        </sidebar-item> -->
        <li class="">
          <a :href="reporting" class="nav-link" target="_blank" @click="reportingClick"
            ><i class="md-icon md-icon-font md-theme-default">dynamic_feed</i>
            <p>Reporting</p></a
          >
        </li>
        <li class="bottom">
          <sidebar-item
            :link="{
              name: 'Pricing Strategies',
              icon: '',
              path: '/pricing-strategies',
            }"
          >
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'Pricing rules',
              icon: '',
              path: '/pricing-rules',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Allotment rules',
              icon: '',
              path: '/allotment-rules',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Pax grid',
              icon: '',
              path: '/pax-grid',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="checkRoleGroupAccess()"
            :link="{
              name: 'Groups List',
              icon: '',
              path: '/groups-list',
            }"
          ></sidebar-item>
        </li>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="300" mode="out-in" v-if="this.$root.hotelId">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="false && !$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`, { wheelSpeed: 0.5 })
    document.getElementsByClassName(className)[0].scrollTop = 0
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList
  let isWindows = navigator.platform.startsWith('Win')
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function

    //initScrollbar('sidebar')
    //initScrollbar('sidebar-wrapper')
    //initScrollbar('main-panel')

    docClasses.add('perfect-scrollbar-on')
  } else {
    docClasses.add('perfect-scrollbar-off')
  }
}

import Swal from 'sweetalert2'
import { ZoomCenterTransition } from 'vue2-transitions'
import MetabaseApi from '../../openapi/src/api/MetabaseApi'
import ContentFooter from './ContentFooter.vue'
import HotelSelection from './Extra/HotelSelection.vue'
import TopNavbar from './TopNavbar.vue'

const metabaseApi = new MetabaseApi()

export default {
  components: {
    TopNavbar,
    ContentFooter,
    ZoomCenterTransition,
    HotelSelection,
  },
  data() {
    return {
      sidebarBackgroundColor: 'black',
      sidebarBackground: 'purple',
      sidebarBackgroundImage: './img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
      reporting: null,
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    reportingClick() {
      if (this.reporting == null) {
        Swal.fire({
          title: 'Missing reporting url',
          buttonsStyling: false,
          confirmButtonClass: 'md-button md-success',
        })
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    initMetabase() {
      if (this.$root.hotelId) {
        metabaseApi.getMetabase(this.$root.hotelId, (error, data) => {
          this.reporting = data.metabase_url
        })
      } else {
        setTimeout(() => this.initMetabase(), 100)
      }
    },
    checkRoleAdminAccess() {
      return this.$root.hasBackendRole('admin')
    },
    checkRoleGroupAccess() {
      return this.$root.hasBackendRole('group_read')
    },
  },
  updated() {
    reinitScrollbar()
  },
  mounted() {
    reinitScrollbar()
    this.initMetabase()
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar()
    },
  },
}
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.frontend-sidebar ul {
  height: calc(100vh - 190px);
}

.frontend-sidebar .bottom {
  bottom: 0;
  position: absolute;
  width: 100%;
}
.md-toolbar.md-theme-default.md-primary {
  background-color: #402d32 !important;
}
.md-toolbar.md-primary .md-title {
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #f6dcda !important;
}
.sidebar[data-background-color='black'] .md-list li .nav-link,
.off-canvas-sidebar[data-background-color='black'] .md-list li .nav-link {
  color: #f6dcda !important;
  background: #402d32;
  border-radius: 4px;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
}
.sidebar[data-background-color='black'] .md-list li .nav-link p,
.off-canvas-sidebar[data-background-color='black'] .md-list li .nav-link p {
  font-weight: 500;
  font-size: 14px;
}
.sidebar[data-background-color='black'] .md-list li .nav-link.active,
.off-canvas-sidebar[data-background-color='black'] .md-list li .nav-link.active {
  background-color: #f6dcda;
  color: #201b1e !important;
}
.sidebar[data-color='purple'] li.active > a:not([data-toggle='collapse']) .md-icon.md-theme-default.md-icon-font,
.off-canvas-sidebar[data-color='purple'] li.active > a:not([data-toggle='collapse']) .md-icon.md-theme-default.md-icon-font {
  filter: brightness(0%);
}
.sidebar[data-background-color='black'] .md-list li.bottom .nav-link,
.off-canvas-sidebar[data-background-color='black'] .md-list li.bottom .nav-link {
  border: 1px solid #f6dcda;
}
.sidebar[data-background-color='black'] .md-list li.bottom .nav-link p,
.off-canvas-sidebar[data-background-color='black'] .md-list li.bottom .nav-link p {
  line-height: 15px;
}
.sidebar[data-background-color='black'] .md-list li.bottom .nav-link i.md-icon,
.off-canvas-sidebar[data-background-color='black'] .md-list li.bottom .nav-link i.md-icon {
  display: none;
}
.off-canvas-sidebar[data-background-color='black'] .md-list li.bottom > li:first-child {
  margin-bottom: 24px;
}
.off-canvas-sidebar[data-background-color='black'] .md-list li.bottom > li:first-child p {
  font-size: 11px;
}
.md-card.md-theme-default {
  border: none;
  box-shadow: 0px 11px 9px -8px rgba(31, 30, 30, 0.2);
  border-radius: 8px;
}

@media screen and (max-height: 700px) {
  .frontend-sidebar .bottom {
    position: inherit;
  }
}
</style>
